import { ResolveFn } from '@angular/router';
import { IDataPayloadSingle } from '../core/http/http.interface';
import { TGsaInfo } from './gsa-info.interface';
import { inject } from '@angular/core';
import { GsaInfoService } from './gsa-info.service';

export const gsaInfoResolver: ResolveFn<IDataPayloadSingle<TGsaInfo>> = () =>
  inject(GsaInfoService).getGsaInfoContent();
